import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  margin-top: 2rem;
  text-align: center;

  @media (min-width: 1280px) {
    margin-right: 2rem;
  }
`;

export const Title = styled.h2`
  color: #fff;
  font-size: 2rem;
`;

export const Container = styled.h2`
  height: 20rem;
`;
